export default {"src":"/_next/static/media/bazel_logo.b06324ec.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};